import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpLiveViewSliceFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpEvaluationResultFactory } from "./ExpEvaluationResult";
// @ts-ignore noUnusedLocals
import { ExpTestDataResultFactory } from "./ExpTestDataResult";
// @ts-ignore noUnusedLocals
import { ExpExpressionDefinitionFactory } from "./ExpExpressionDefinition";
// @ts-ignore noUnusedLocals
import { ExpValidationResultFactory } from "./ExpValidationResult";

/**
 * 
 * @export
 * @interface ExpLiveViewSlice
 */

export class ExpLiveViewSliceFactory {}
_ExpLiveViewSliceFactory = ExpLiveViewSliceFactory;
_defineProperty(ExpLiveViewSliceFactory, "FromJSON", function (json) {
  return _ExpLiveViewSliceFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpLiveViewSliceFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'generationSuccess': json['generationSuccess'],
    'generationFailureMessage': json['generationFailureMessage'],
    'expressionDefinition': json['expressionDefinition'] === null || json['expressionDefinition'] === undefined ? json['expressionDefinition'] : ExpExpressionDefinitionFactory.FromJSON(json['expressionDefinition']),
    'testDataResults': json['testDataResults'].map(ExpTestDataResultFactory.FromJSON),
    'evaluationResults': json['evaluationResults'].map(ExpEvaluationResultFactory.FromJSON),
    'validationResults': json['validationResults'].map(ExpValidationResultFactory.FromJSON)
  };
});
_defineProperty(ExpLiveViewSliceFactory, "ToJSON", function (value) {
  return _ExpLiveViewSliceFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpLiveViewSliceFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'generationSuccess': value.generationSuccess,
    'generationFailureMessage': value.generationFailureMessage,
    'expressionDefinition': ExpExpressionDefinitionFactory.ToJSON(value.expressionDefinition),
    'testDataResults': value.testDataResults.map(ExpTestDataResultFactory.ToJSON),
    'evaluationResults': value.evaluationResults.map(ExpEvaluationResultFactory.ToJSON),
    'validationResults': value.validationResults.map(ExpValidationResultFactory.ToJSON)
  };
});
//# sourceMappingURL=ExpLiveViewSlice.js.map
